import { Injectable } from '@angular/core';
import { DataTaskService } from '@app/core/services/data-task.service';

@Injectable({
    providedIn: 'root',
})
export class ProductGroupService {
    constructor(private datatask: DataTaskService) {}

    /**
     * Retrieves list over product groups.
     *
     * @datatask 41
     * @datataskName sp_ws_p2_prodgrp_select_list
     * @param params
     * @returns a promise containing list over product groups.
     */
    public getProductGroups(params?: GetProductGroupsParams): Promise<ProductGroupItem[]> {
        return this.datatask.Post(41, params);
    }

    /**
     * Retrieves list over product groups 2.
     *
     * @datatask 961
     * @datataskName sp_ws_p2_prodgrp2_list
     * @param params
     * @returns a promise containing list over product groups 2.
     */
    public getProductGroup2s(params?: GetProductGroup2sParams): Promise<ProductGroup2Item[]> {
        return this.datatask.Post(961, params);
    }

    /**
     * Retrieves list over product group3s.
     *
     * @datatask 3085
     * @datataskName sp_ws_p2_prodgrp3_list
     * @param params
     * @returns a promise containing list over product groups 3.
     */
    public getProductGroup3s(params?: GetProductGroup3sParams): Promise<ProductGroup3Item[]> {
        return this.datatask.Post(3085, params);
    }

    /**
     * Retrieves list over product groups 4.
     *
     * @datatask 3086
     * @datataskName sp_ws_p2_prodgrp4_list
     * @param params
     * @returns a promise containing list over product groups 4.
     */
    public getProductGroup4s(params?: GetProductGroup4sParams): Promise<ProductGroup4Item[]> {
        return this.datatask.Post(3086, params);
    }
}

export interface GetProductGroup2sParams {
    prodgrp_id: string;
}

export interface GetProductGroup3sParams {
    prodgrp2_id: string;
}

export interface GetProductGroup4sParams {
    prodgrp3_id: string;
}

export interface ProductGroup2Item {
    item_id: string;
    item_name: string;
    item_path: string;
    item_state: string;
    item_parms: string;
    orderby: string;
    item_glyphicon: string;
    item_glyphicon_color: string;
    item_filtervalue: string;
}

export interface ProductGroup3Item extends ProductGroup2Item {}

export interface ProductGroup4Item extends ProductGroup2Item {}

export interface GetProductGroupsParams {
    /**
     * @default '0'
     */
    add_all?: '1' | '0';
}

/**
 * Represents a product group list item.
 */
export interface ProductGroupItem {
    /**
     * The id of the product group.
     */
    prodgrp_id: string;

    /**
     * The name of the product group.
     */
    prodgrp_name: string;

    /**
     * The order place in the list of this product group.
     */
    orderby: string;
}
